import React from "react";
import { sections } from "../../../lib/constant";
import SectionWrapper from "../section/section wrapper/SectionWrapper";
import { componentMapping } from "../section";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowRight, faPalette} from "@fortawesome/pro-solid-svg-icons";
import { ScrollArea } from "./ScrollArea";
import { useAppContext } from "../../../context/AppContext";

import { buttonVariants } from "./Button";
import { cn } from "../../../lib/utils";
import {useFormContext} from "react-hook-form";
import { toast } from "sonner"


const Drawer = ({ type }) => {
    const {
        state: { view, sidebarOpen },
        setCurrentPage,
    } = useAppContext();
    const filteredSections = sections.filter(
        (section) =>
            section.visibleFor.includes(type) && section.view.includes(view)
    );
    const {trigger,formState:{errors},getValues} = useFormContext();

    // const external_door_style = watch('external_door_style')

    // // Add Oxide Range conditionally
    // if (external_door_style === 'sumatra') {
    //     const oxideSection = {
    //         id: 1,
    //         name: "Oxide Range",
    //         visibleFor: ["trade", "customer"],
    //         view: ["old external"],
    //         icon: faPalette,
    //         component: "OxideRange",
    //     };
    //     filteredSections.splice(1, 0, oxideSection); // Adjust the index as needed
    // }


    return (
        <ScrollArea
            className={cn(
                "w-full xl:w-[28%] bg-white shadow-md h-[68vh] sm:h-[60%] xl:h-full",
                {
                    ["xl:w-0"]: !sidebarOpen,
                }
            )}
        >
            <div className="relative bg-[#EEEEEE] mb-[calc(3rem+var(--mobile-bottom-clearance))] lg:mb-12 w-full">
                {filteredSections.map(({ name, icon, id, component,subtitle,oxide,input_name }) => {
                    const SectionComponent = componentMapping[component];
                    return (
                        <SectionWrapper
                            name={name}
                            icon={icon}
                            key={name}
                            Component={SectionComponent}
                            componentName={component}
                            subtitle={subtitle}
                            oxide={oxide}
                            input_name={input_name}
                        />
                    );
                })}
                <div
                    className={cn(
                        "w-full lg:w-[28%] fixed bottom-0 right-0 z-20 bg-white pb-[var(--mobile-bottom-clearance)] lg:bg-transparent lg:pb-0",
                        {
                            ["xl:w-0"]: !sidebarOpen,
                        }
                    )}
                >
                    <button
                        onClick={async () => {
                            const isValid =    await trigger(['aperture_height','aperture_width','height','width'])
                            console.log(getValues('aperture_width'))
                            if (!isValid) {
                                if (Object.keys(errors).length) {
                                    for (const [key, value] of Object.entries(errors)) {
                                        toast.error(`Please Make sure ${key} is set correctly`,{
                                            duration: 5000,
                                        })
                                    }
                                }
                            }
                            if(isValid) {
                                setCurrentPage("summary")
                            }

                        }}
                        type="button"
                        className={buttonVariants({
                            className:
                                "flex items-center justify-between gap-1 w-full uppercase",
                        })}
                    >
                        Continue
                        <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                </div>
            </div>
        </ScrollArea>
    );
};

export default Drawer;
